import {AccountType} from "@qid/core";
import {AesRsaEncryptedData} from "@qid/crypto";
import {DocumentData} from "../models/document-data.model";
import {SID} from "../../sid";

export class CreateIdDto {

  account_id: string;
  accountType: AccountType
  documentNumberMasked: string;
  documentNumberHash: string;
  sid: SID;
  aesRsaEncryptedData: AesRsaEncryptedData
  documentData: DocumentData
  recipientEntityId?: string;

  constructor() {
  }
}
